import React from "react";
import TextareaAutosize from "react-textarea-autosize";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../../app/helpers/helperCatalogs";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
  handleEditFormSubmit,
  comboData,
  moduleText
}) => {

    const { t } = useTranslation();

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <tr>
      <td style={{width:'20%'}}>
        <TextareaAutosize
            cacheMeasurements
            className="form-control"
            aria-label="empty textarea"
            style={{ width: "100%" }}
            onChange={(event) => handleEditFormChange(event, "name", "text")}
            
            maxRows={5}
            name="name"
            id="name"
            value={editFormData.name}
            required
            maxLength="200"
            placeholder={t(`${moduleText}.table_multimedias.name`)}
          ></TextareaAutosize>
      </td>
      <td style={{width:'20%'}}>
        <TextareaAutosize
            cacheMeasurements
            className="form-control"
            aria-label="empty textarea"
            style={{ width: "100%" }}
            onChange={(event) => handleEditFormChange(event, "description", "text")}
            
            maxRows={5}
            name="description"
            id="description"
            value={editFormData.description}
            required
            maxLength="200"
            placeholder={t(`${moduleText}.table_multimedias.description`)}
          ></TextareaAutosize>
      </td>
      <td style={{width:'20%'}}>
        <TextareaAutosize
            cacheMeasurements
            className="form-control"
            aria-label="empty textarea"
            style={{ width: "100%" }}
            onChange={(event) => handleEditFormChange(event, "url", "text")}
            
            maxRows={5}
            name="url"
            id="url"
            value={editFormData.url}
            required
            maxLength="200"
            placeholder={t(`${moduleText}.table_multimedias.url`)}
          ></TextareaAutosize>
      </td>
      <td style={{width:'30%'}}>
        <Select
            styles={customStyles}
            
            myFontSize="14px"
            style={{ width: "100%" }}
            
            onChange={(event) => handleEditFormChange(event, "CatMulti_To_ModFile", "relation")}
            
            classNamePrefix="select"
            
            name="CatMulti_To_ModFile"
            
            inputId="CatMulti_To_ModFile"
            
            value={editFormData.CatMulti_To_ModFile}

            options={comboData}
            getOptionLabel={(option) => catalogTableLabel(option)}
            getOptionValue={(option) => `${option}`}
            isClearable={true}
            isSearchable={true}
            placeholder={t(`${moduleText}.table_multimedias.multimedia_type`)}
          />
      </td>
      {/*<td>
      {showComponentPreviewFile(editFormData.url)}
      </td>*/}
      <td style={{width:'10%'}}>
        {/*<button type="submit">Save</button>*/}
        <button style={{border:'none'}} onClick={handleEditFormSubmit}>
        <i className="fa fa-save table-button-save"></i>
        </button>
        <button style={{border:'none'}} type="button" onClick={handleCancelClick}>
           <i className="fa fa-times-circle table-button-cancel"></i>
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;
